import React from 'react';
import './InnerPage.css';
import './LocationPage.css';

const nearbyPoints = [
  { icon: '✈️', cat: 'Airport', name: 'Noida International Airport (Jewar)', dist: '20 Min' },
  { icon: '🎬', cat: 'Entertainment', name: 'YEIDA Film City', dist: '20 Min' },
  { icon: '🏎️', cat: 'Sports', name: 'Buddh International Circuit (F1)', dist: '15 Min' },
  { icon: '🚂', cat: 'Railway', name: 'Dankaur Railway Station', dist: '8 Min' },
  { icon: '🚇', cat: 'Metro', name: 'Upcoming Metro Station', dist: '1 Km' },
  { icon: '🛍️', cat: 'Shopping', name: 'Gaur City Mall', dist: '4 Km' },
  { icon: '💎', cat: 'Shopping', name: 'Galaxy Diamond Plaza', dist: '5 Km' },
  { icon: '🏫', cat: 'Education', name: 'SKS World School', dist: '1 Km' },
  { icon: '🏫', cat: 'Education', name: 'Wisdom Tree School', dist: '1 Km' },
  { icon: '🏥', cat: 'Hospital', name: 'Yashoda Hospital', dist: '3 Km' },
  { icon: '🏥', cat: 'Hospital', name: 'Yatharth Super Speciality', dist: '5 Km' },
  { icon: '🏛️', cat: 'Landmark', name: '1 Murti Chowk', dist: '2.5 Km' },
];

const whyGN = [
  { icon: '📈', title: '200–300% ROI', desc: 'Expected appreciation by 2030 near Jewar Airport belt' },
  { icon: '✈️', title: 'Jewar Airport', desc: 'India\'s largest greenfield airport, commercial flights from June 2026' },
  { icon: '🎬', title: 'Film City', desc: '1000-acre YEIDA Film City — ₹65,000 Cr investment, 50,000+ jobs' },
  { icon: '🏭', title: 'Industrial Hub', desc: 'Foxconn, Havells, Vivo setting up factories — driving demand' },
  { icon: '🚇', title: 'Metro Connectivity', desc: 'Upcoming metro extension connecting Greater Noida West' },
  { icon: '🌿', title: 'Green Living', desc: 'Low-density planned townships with parks, wide roads & green spaces' },
];

export default function LocationPage() {
  return (
    <div className="inner-page">
      <div className="inner-hero" style={{ background: 'linear-gradient(135deg,#0F1A2E,#1B3A5C)' }}>
        <div className="inner-hero-content">
          <span className="inner-eyebrow">Where We Are</span>
          <h1>Greater Noida <span className="gold">West</span></h1>
          <p>NCR's fastest-growing real estate corridor — near Jewar Airport & YEIDA Film City</p>
        </div>
      </div>

      <div className="loc-container">

        {/* Why Greater Noida */}
        <div className="loc-section">
          <h2>Why Invest in Greater Noida West?</h2>
          <div className="loc-why-grid">
            {whyGN.map((w, i) => (
              <div className="loc-why-card" key={i}>
                <div className="loc-why-icon">{w.icon}</div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Nearby Places */}
        <div className="loc-section">
          <h2>Nearby Places & Connectivity</h2>
          <div className="loc-nearby-grid">
            {nearbyPoints.map((n, i) => (
              <div className="loc-nearby-item" key={i}>
                <span className="loc-nearby-icon">{n.icon}</span>
                <div className="loc-nearby-info">
                  <span className="loc-nearby-cat">{n.cat}</span>
                  <strong>{n.name}</strong>
                </div>
                <div className="loc-nearby-dist">{n.dist}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Map */}
        <div className="loc-section">
          <h2>Our Project Locations</h2>
          <div className="loc-map-wrap">
            <iframe
              title="Greater Noida West Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d112070.78!2d77.38!3d28.62!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sGreater%20Noida%20West!5e0!3m2!1sen!2sin!4v1699999999999"
              width="100%" height="440"
              style={{ border: 0, borderRadius: 16 }}
              allowFullScreen="" loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
